/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const teamCoFounderDtoSchema = z.object({
  name: z.optional(z.string()),
  role: z.optional(z.string()),
  timeCommitment: z.optional(z.string()),
  since: z.optional(z.string()),
  bullets: z.optional(z.array(z.string())),
  linkedin: z.optional(z.string()),
});
